import { render, staticRenderFns } from "./EditRetailer.vue?vue&type=template&id=914289de&"
import script from "./EditRetailer.vue?vue&type=script&lang=js&"
export * from "./EditRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports